import React, { useEffect,useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as technicianActions from 'actions/technicianActions';
import * as formActions from 'actions/formActions';
import TechnicianForm from 'components/technicians/TechnicianForm';
import Logger from 'util/Logger';
import {
  Header,
  HeaderButtonNav,
  HeaderButton,
  HeaderTitle
} from 'components/layout';
import * as operationsApi from 'api/operationsApi';
import { useParams,useNavigate } from 'react-router-dom';

/*const propTypes = {
  actions: PropTypes.object
};*/
const CreateTechnicianPage=({actions})=>{
  const { action: mode, id: technicianId } = useParams();
  const [loaded, setLoaded] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [technician, setTechnician] = useState(null);
  const navigate = useNavigate();

useEffect(()=>{
  if(mode=='edit'){
    getTechnician(technicianId);
  }
},[mode, technicianId]);

/*class CreateTechnicianPage extends Component {
  state = {
    loaded: false,
    isSubmitting: false
  };

  componentDidMount() {
    const { technicianId, mode } = this.props;
    if (mode === 'edit') {
      this.getTechnician(technicianId);
    }
  }*/
    const getTechnician = async (id) => {
      const result = await operationsApi.getTechnician(id);
      setTechnician(result.data);
      setLoaded(true);
    };

    const createOrUpdateSuccess = (message) => {
      setIsSubmitting(false);
      actions.getTechnicians();
      Logger.success(message);
      navigate('/technicians');
    };

    const createTechnician = async (formValues) => {
      setIsSubmitting(true);
      await operationsApi.createNewTechnician(formValues);
      createOrUpdateSuccess('New Technician Created');
    };
  
    const updateTechnician = async (formValues) => {
      setIsSubmitting(true);
      await operationsApi.updateTechnician(formValues);
      createOrUpdateSuccess('Technician Updated');
    };
  
    const cancel = () => {
      navigate('/technicians');
    };
  
    if (mode === 'edit' && !loaded) {
      return null;
    }
  

  /*const createOrUpdateSuccess = (message) => {
    let { actions, history } = this.props;
    toggleFormSubmit();
    actions.getTechnicians();
    Logger.success(message);
    history.push('/technicians');
  };*/

  /*const getTechnician = technicianId => {
    operationsApi.getTechnician(technicianId).then(result => {
      this.setState({
        loaded: true,
        technician: result.data
      });
    });
  };*/

  /*const createTechnician = formValues => {
    toggleFormSubmit();
    operationsApi.createNewTechnician(formValues).then(() => {
      createOrUpdateSuccess('New Technician Created');
    });
  };

  const updateTechnician = formValues => {
    toggleFormSubmit();
    operationsApi.updateTechnician(formValues).then(() => {
      createOrUpdateSuccess('Technician Updated');
    });
  };

  const toggleFormSubmit = () => {
    this.setState(prevState => ({
      isSubmitting: !prevState.isSubmitting
    }));
  };

  const cancel = () => {
    //this.props.history.push('/technicians');
    navigate('/technicians');
  };

  /*render() {
    const { mode } = this.props;
    const { loaded, technician } = this.state;

    if (mode === 'edit' && !loaded) {
      return null;
    }*/

    return (
      <div>
        <Header>
          <HeaderButtonNav>
            <HeaderButton
              color="primary"
              onClick={cancel}
              ligature="clear"
            />
          </HeaderButtonNav>
          <HeaderTitle label={`Create a New Technician`} />
        </Header>
        <TechnicianForm
          onSubmit={
            mode === 'edit' ? updateTechnician : createTechnician
          }
        //  isSubmitting={this.state.isSubmitting}
          initialValues={mode === 'edit' ? technician : {}}
        />
      </div>
    );
  }
//}

CreateTechnicianPage.propTypes = {  actions: PropTypes.object.isRequired}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      {
        ...technicianActions,
        ...formActions
      },
      dispatch
    )
  };
}

export default connect(null, mapDispatchToProps)(CreateTechnicianPage);
